import React from "react";

export const EscapeGallery = ({ parent, photos }) => (
  <section
    data-testid="escape-gallery"
    className="mx-auto max-w-[1400px] px-6 pt-20 md:px-10 md:pt-24"
  >
    <p className="overline text-brand-inkSoft">A closer look</p>
    <h2 className="font-display mt-3 text-3xl leading-tight md:text-4xl">
      {parent.title} <em className="italic text-brand-terracotta">in photos</em>
    </h2>

    <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3">
      {photos.map((p, i) => (
        <figure
          key={p.id}
          data-testid={`gallery-photo-${i + 1}`}
          className={`group relative overflow-hidden rounded-2xl bg-brand-bg2 fade-up ${
            i === 0 ? "col-span-2 md:col-span-2 md:row-span-2" : ""
          }`}
          style={{ animationDelay: `${Math.min(i, 6) * 60}ms` }}
        >
          <div className={`relative w-full ${i === 0 ? "aspect-[16/11]" : "aspect-[4/3]"}`}>
            <img
              src={p.src}
              alt={p.caption}
              loading="lazy"
              onError={(e) => {
                if (e.currentTarget.src !== parent.image) e.currentTarget.src = parent.image;
              }}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-black/0" />
          </div>
          <figcaption className="absolute inset-x-0 bottom-0 p-4 text-sm font-medium text-white md:text-base">
            {p.caption}
          </figcaption>
        </figure>
      ))}
    </div>
  </section>
);

export default EscapeGallery;
